import { apiRequest } from '../../lib/api';
import { authMeSchema, authResultSchema, okSchema } from '../../lib/schemas';

export const getCurrentSession = () => apiRequest('/api/auth/me', authMeSchema);

export const login = (body: { username: string; password: string; code: string }) =>
  apiRequest('/api/auth/login', authResultSchema, {
    method: 'POST',
    body: JSON.stringify(body),
    handleUnauthorized: false,
  });

export const setupFirstAdmin = (body: { username: string; password: string }) =>
  apiRequest('/api/auth/setup', authResultSchema, {
    method: 'POST',
    body: JSON.stringify(body),
    handleUnauthorized: false,
  });

export const signup = (body: {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  code: string;
}) => apiRequest('/api/auth/signup', authResultSchema, {
  method: 'POST',
  body: JSON.stringify(body),
  handleUnauthorized: false,
});

export const logout = () => apiRequest('/api/auth/logout', okSchema, {
  method: 'POST',
  handleUnauthorized: false,
});

export const requestPasswordReset = (username: string) =>
  apiRequest('/api/auth/reset-request', okSchema, {
    method: 'POST',
    body: JSON.stringify({ username }),
    handleUnauthorized: false,
  });
